/**
 * Resolve tenant/company display name from live API (never hardcode).
 */
function decodeJwtPayload(token) {
  try {
    const parts = String(token || "").split(".");
    if (parts.length < 2) return null;
    const pad = "=".repeat((4 - (parts[1].length % 4)) % 4);
    const json = atob(parts[1].replace(/-/g, "+").replace(/_/g, "/") + pad);
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function tenantHintFromStorage() {
  try {
    const details = JSON.parse(localStorage.getItem("zTaskUserDetails") || "{}");
    const fromUser =
      details.tenant?.displayName ||
      details.tenant?.legalName ||
      details.tenant?.tenantCode ||
      details.companyName ||
      details.tenantName ||
      "";
    if (fromUser) return String(fromUser);

    const token = localStorage.getItem("zTaskAuthToken") || "";
    const payload = decodeJwtPayload(token);
    const claims = payload?.claims || {};
    return claims.tenant_code || claims.tenantCode || "";
  } catch {
    return "";
  }
}

function pickCompanyName(data) {
  if (!data || typeof data !== "object") return "";
  const list = data.message || data.messgae;
  const tenant = data.tenant || data.defaultTenant || {};
  if (Array.isArray(list) && list[0]) {
    const c = list[0];
    return (
      c.companyName ||
      c.company_name ||
      c.companyShortName ||
      c.companyKeyword ||
      c.company_abbr ||
      tenant.displayName ||
      tenant.legalName ||
      tenant.tenantCode ||
      ""
    );
  }
  return tenant.displayName || tenant.legalName || tenant.tenantCode || "";
}

/**
 * @param {string[]} apiBases candidate API origins (auth/java/hr)
 */
export async function fetchTenantBranding(apiBases = []) {
  const token = localStorage.getItem("zTaskAuthToken") || "";
  const hint = tenantHintFromStorage();
  if (!token) return { name: hint || "", logoUrl: null };

  const bases = apiBases
    .map((b) => String(b || "").replace(/\/$/, "").replace(/\/api$/i, ""))
    .filter(Boolean)
    .filter((b, i, arr) => arr.indexOf(b) === i);

  for (const base of bases) {
    try {
      const res = await fetch(`${base}/api/get-company`, {
        headers: { Authorization: `Bearer ${token}`, "X-Client": "web" },
      });
      if (!res.ok) continue;
      const data = await res.json();
      const name = pickCompanyName(data);
      if (name && String(name).toLowerCase() !== "null") {
        const list = data.message || data.messgae;
        const logoUrl = Array.isArray(list) && list[0] ? list[0].logoUrl || null : null;
        return { name: String(name), logoUrl };
      }
    } catch {
      /* next */
    }
  }
  return { name: hint || "", logoUrl: null };
}
